import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://app.adsmash.org/api';

const SubscriptionService = {
  // Get all available subscription plans
  getPlans: async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/subscription/plans`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      
      return response.data.plans;
    } catch (error) {
      console.error('Error fetching subscription plans:', error);
      throw error;
    }
  },
  
  // Create a checkout session
  createCheckoutSession: async (priceId) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${API_URL}/subscription/create-checkout-session`,
        { priceId },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      
      return response.data;
    } catch (error) {
      console.error('Error creating checkout session:', error);
      console.error('Full error response:', error.response);
      console.error('Error data:', error.response?.data);
      
      // Return error object instead of throwing
      return {
        success: false,
        error: error.response?.data?.error || error.message || 'Failed to create checkout session'
      };
    }
  },
  
  // Verify a Stripe session directly
  verifySession: async (sessionId) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${API_URL}/subscription/verify-session`,
        { sessionId },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      
      // Store subscription info in localStorage for immediate access
      if (response.data.success && response.data.subscription) {
        localStorage.setItem('subscription_status', response.data.subscription.status);
        localStorage.setItem('subscription_plan', response.data.subscription.plan);
      }
      
      return response.data;
    } catch (error) {
      console.error('Error verifying session:', error);
      throw error;
    }
  },
  
  // Get subscription details
  getSubscriptionDetails: async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/subscription/subscription-details`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      
      // Store subscription info in localStorage for immediate access
      if (response.data.success && response.data.hasActiveSubscription && response.data.subscription) {
        localStorage.setItem('subscription_status', response.data.subscription.status);
        localStorage.setItem('subscription_plan', response.data.subscription.plan);
      }
      
      return response.data;
    } catch (error) {
      console.error('Error fetching subscription details:', error);
      throw error;
    }
  },
  
  // Access Stripe customer portal
  getCustomerPortal: async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/subscription/customer-portal`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      
      return response.data;
    } catch (error) {
      console.error('Error accessing customer portal:', error);
      throw error;
    }
  },
  
  // Cancel subscription
  cancelSubscription: async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${API_URL}/subscription/cancel`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      
      if (response.data.success) {
        localStorage.setItem('subscription_status', 'canceled');
      }
      
      return response.data;
    } catch (error) {
      console.error('Error canceling subscription:', error);
      throw error;
    }
  },
  
  // Reactivate subscription
  reactivateSubscription: async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${API_URL}/subscription/reactivate`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      
      if (response.data.success) {
        localStorage.setItem('subscription_status', 'active');
      }
      
      return response.data;
    } catch (error) {
      console.error('Error reactivating subscription:', error);
      throw error;
    }
  }
};

export default SubscriptionService; 